import React from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// react router dom
import { Link } from 'react-router-dom';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

export default function CategoryItem(props) {
    // props
    const {
        categoryItem,
        selectedCategory,
        categoryItemIndex,
        handleCategoryNameClick,

        leftBarExpandedCategories,
        handleExpandCategory,

        isSubCategory
    } = props

    // variables
    let multiLevelCategories = null

    // store url
    const [storeUrl] = useStoreUrl()

    // if the category has sub items
    if (categoryItem?.sub_categories?.length) {
        multiLevelCategories = (
            // multilevel data
            <div className={`multilevel-container`}>
                {
                    categoryItem?.sub_categories?.length ? categoryItem?.sub_categories.map((item, index) => {
                        return (
                            <React.Fragment key={item.category_id}>
                                <CategoryItem
                                    categoryItem={item}
                                    categoryItemIndex={index}

                                    selectedCategory={selectedCategory}
                                    handleCategoryNameClick={(ev, id) => handleCategoryNameClick(ev, id)}

                                    leftBarExpandedCategories={leftBarExpandedCategories}
                                    handleExpandCategory={(ev, id) => handleExpandCategory(ev, id)}
                                    isSubCategory={true}
                                />
                            </React.Fragment>
                        )
                    }) : null
                }
            </div>
        )
    }

    return (
        <React.Fragment>
            {/* frac */}
            <div className={`frac ${isSubCategory ? "sub-cat" : ""} ${leftBarExpandedCategories.find(item => item === categoryItem.category_id) ? "expanded" : "shrunk"}`}
                data-index={categoryItemIndex}
                data-key={categoryItem.category_id}
                key={categoryItem.category_id}>
                {/* frac-item */}
                <div className="frac-item">
                    <div className="top-sec d-flex">
                        {
                            /* icon */
                            categoryItem?.sub_categories?.length ? (
                                <button
                                    type="button"
                                    className="expand-shrink-icon st-round-btn st-btn-xs st-btn-white d-flex align-items-center justify-content-center me-1"
                                    onClick={ev => handleExpandCategory(ev, categoryItem.category_id)}>
                                    <FeatherIcon
                                        icon={leftBarExpandedCategories.find(item => item === categoryItem.category_id) ? "minus" : "plus"}
                                        size="15"
                                        className="icon" />
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="expand-shrink-icon st-round-btn st-btn-xs st-btn-white d-flex align-items-center justify-content-center me-1 disabled" style={{ opacity: 0, pointerEvents: 'none' }}>
                                </button>
                            )
                        }
                        {/* name */}
                        <Link
                            to={`${storeUrl}/catalog/categories?category=${categoryItem.category_id}${isSubCategory ? "&mode=editSubCat" : "&mode=edit"}`}
                            className={`category-name text-decoration-none ${parseInt(selectedCategory) === categoryItem.category_id ? "selected" : ""}`}>
                            {/* name */}
                            <span>{categoryItem.category_name}</span>
                        </Link>
                    </div>

                    {/* multilevel category */}
                    {multiLevelCategories}
                </div>
            </div>
        </React.Fragment>
    )
}
